module.exports = __webpack_public_path__ + "static/media/footer_logo.3aa22070.png";